/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Row, Col, Button, Tabs, Tab, Form, Pagination } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { loaderActions } from '../../../features/Loader/LoaderSlice';
import { LoadUsersRequest, userActions } from '../../../features/User/UserSlice';
import UserForm from './Components/UserForm';
import UserTable from './Components/UserTable';
import axios from 'axios';

function Management() {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const [currentTab, setCurrentTab] = useState(() => {
    if (searchParams.get('role') && searchParams.get('role') === 'none') {
      return 'admin';
    }
    return searchParams.get('role');
  });

  const [search, setSearch] = useState('');
  const [modalShow, setModalShow] = useState(false);
  const [modalStatus, setModalStatus] = useState('new');
  const [userToEdit, setUserToEdit] = useState({});
  const [verificationMethod, setVerificationMethod] = useState('');

  const { list: Users } = useSelector((state) => state.user);

  useEffect(() => {
    fetchUsers();
    dispatch(userActions.SetGroupName(currentTab));
    setSearchParams(`?${new URLSearchParams({ role: currentTab })}`);
  }, [currentTab]);

  function openModal(status) {
    setModalStatus(status);
    setModalShow(true);
  }

  function hideModal(status = 'close') {
    setModalShow(false);
    if (status === 'reload') {
      fetchUsers();
    }
  }
  async function fetchUsers() {
    await dispatch(loaderActions.show());
    await dispatch(LoadUsersRequest({ groupName: currentTab, params: { limit: 50 } }));
    await dispatch(loaderActions.hide());
  }

  const filterUsers = Users.filter((user) =>
    user.email.toLowerCase().includes(search.trim().toLowerCase())
  );

  const userGroups = [
    {
      title: 'EVP Super Admins',
      role: 'admin'
    },
    {
      title: 'Senior Team Lead',
      role: 'senior-team-lead'
    },
    {
      title: 'Team Lead',
      role: 'team-lead'
    },
    {
      title: 'Supervisors',
      role: 'supervisor'
    },
    {
      title: 'Managers',
      role: 'manager'
    },
    {
      title: 'All Users',
      role: 'all'
    }
  ];

  const UserTabs = userGroups.map((group, idx) => {
    return (
      <Tab eventKey={group.role} title={group.title} key={idx}>
        <UserTable
          group={group}
          users={filterUsers}
          fetchUsers={fetchUsers}
          setUserToEdit={setUserToEdit}
          openModal={openModal}
          verificationMethod={verificationMethod}
        />
      </Tab>
    );
  });

  function SignupConfirmation() {
    const url = process.env.REACT_APP_API_URL;
    axios
      .get(`${url}/userbase`, {
        headers: {
          'content-type': 'application/json',
          Accept: '*/*'
        }
      })
      .then((result) => {
        setVerificationMethod(result.data.verification_method);
      });
  }

  useEffect(() => {
    SignupConfirmation();
  }, []);

  return (
    <>
      <Row className="px-4 text-right">
        <Col></Col>
        <Col md="auto">
          <Form.Control
            size="sm"
            type="text"
            className="mr-2"
            placeholder={`Search ${
              currentTab === 'admin'
                ? 'EVP Super Admins'
                : currentTab === 'manager'
                ? 'Manager'
                : currentTab === 'supervisors'
                ? 'Supervisors'
                : 'All Users'
            }`}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Col>
        {currentTab !== 'all' && (
          <Col xs lg="2">
            <Button variant="success" onClick={() => openModal('new')}>
              <i className="feather icon-plus" /> Add
            </Button>
          </Col>
        )}
      </Row>
      <Tabs
        defaultActiveKey={currentTab}
        transition={false}
        id="users-tab"
        onSelect={(tab) => setCurrentTab(tab)}
      >
        {UserTabs}
      </Tabs>
      <UserForm
        show={modalShow}
        onHide={hideModal}
        modalStatus={modalStatus}
        user={userToEdit}
        role={currentTab}
      />
    </>
  );
}

export default Management;
